import { Button } from '@components/Button'
import { Dropdown } from '@components/Dropdown'
import Modal from '@components/Modal'
import React, { useEffect, useState } from 'react'
import { ModalActions } from './MoveEventModal.styles'

export interface DayOption {
	dayIndex: number
	label: string
}

export interface MoveEventModalProps {
	isOpen: boolean
	eventName: string
	currentDay: number
	days: DayOption[]
	onClose: () => void
	onMove: (dayIndex: number) => void
}

/** Picks the day an event moves to; the event lands at the end of that day. */
const MoveEventModal: React.FC<MoveEventModalProps> = ({ isOpen, eventName, currentDay, days, onClose, onMove }) => {
	const [target, setTarget] = useState(String(currentDay))

	useEffect(() => {
		if (isOpen) setTarget(String(currentDay))
	}, [isOpen, currentDay])

	const options = days.map(d => ({ value: String(d.dayIndex), label: d.label }))
	const unchanged = Number(target) === currentDay

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={`Move '${eventName}'`}
			size="small"
			footer={
				<ModalActions>
					<Button type="button" variant="secondary" onClick={onClose}>
						Cancel
					</Button>
					<Button type="button" disabled={unchanged} onClick={() => onMove(Number(target))}>
						Move
					</Button>
				</ModalActions>
			}
		>
			<Dropdown aria-label="Move to day" options={options} value={target} onChange={setTarget} />
		</Modal>
	)
}

export default MoveEventModal
